import React, { useState, useEffect } from 'react';

import * as d3 from "d3";
import ReactLoading from 'react-loading';

import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';

import HeatMap from '../components/D3/HeatMap.js';

import {
  getVehicleDaysD3,
  getUserAgency, getAllAgencies,
  getUser
} from '../API';

import { useTranslation } from "react-i18next";

function VehicleDays() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const [kpiname, setKpiName] = useState('Distance (km)');
  const [loading, setLoading] = useState(0);
  const [kpi, setKpi] = useState('distance');

  const [refreshKey, setRefreshKey] = useState(0);
  const [chartData, setChartData] = useState([]);

  const [agency, setAgency] = useState('');
  const [user, setUser] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [userAgency, setUserAgency] = useState('');

  const [initDate, setInitDate] = useState(dayjs().add(1, 'day').format('YYYY-MM-DD'));
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [startFormat, setStartFormat] = useState(dayjs().add(-15, 'day').format('YYYY-MM-DD'));
  const [endFormat, setEndFormat] = useState(dayjs().add(-1, 'day').format('YYYY-MM-DD'));


  useEffect(() => {

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })

    getUser()
      .then(response => {
        setUser(response.user);
      })

    getUserAgency()
      .then(response => {
        setUserAgency(response);
      })

  }, []);


  //Prepare chart
  useEffect(() => {

    setLoading(1);

    let selectedAgency = agency;
    let kpiChoice = kpi;
    let kpiNameChoice = kpiname;

    getVehicleDaysD3(selectedAgency, kpiChoice, kpiNameChoice, startFormat, endFormat)
      .then((response) => {
        setChartData(response);
        setLoading(0);
      })

  }, [refreshKey])


  const handleAgencySelect = (e) => {

    d3.select("g").remove();
    document.getElementById('tooltipid').remove();

    setAgency(e.target.value);
    setLoading(1);
    setRefreshKey(oldKey => oldKey + 1);

  }

  const handleKPISelect = (e) => {

    d3.select("g").remove()
    document.getElementById('tooltipid').remove();

    if (e.target.value == t('vehdays.kpi.dist')) {

      setLoading(1);
      setKpi('distance');
      setKpiName(t('vehdays.kpi.dist'));

    } else if (e.target.value == t('vehdays.kpi.runtime')) {

      setLoading(1);
      setKpi('duree');
      setKpiName(t('vehdays.kpi.runtime'));

    } else if (e.target.value == t('vehdays.kpi.speed')) {

      setLoading(1);
      setKpi('vitesse');
      setKpiName(t('vehdays.kpi.speed'));

    } else if (e.target.value == t('vehdays.kpi.occ')) {

      setLoading(1);
      setKpi('charge');
      setKpiName(t('vehdays.kpi.occ'));

    } else {

      setLoading(1);
      setKpi('points');
      setKpiName(t('vehdays.kpi.datapoints'));

    }

    setRefreshKey(oldKey => oldKey + 1);

  }

  const handleChangeDate = (dates) => {

    const [start, end] = dates;

    if (dayjs(start).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')) {
      setInitDate(dayjs().format('YYYY-MM-DD'));
    }

    setStartDate(start);
    setEndDate(end);
    setEndFormat('');


    if (end !== null) {

      setLoading(1);

      d3.select("g").remove();
      document.getElementById('tooltipid').remove();

      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');

      setStartFormat(formatstart);
      setEndFormat(formatend);
      setInitDate(dayjs().add(1, 'day').format('YYYY-MM-DD'));
      setRefreshKey(oldKey => oldKey + 1);
    }

  };


  return (
    userAgency ?
      <>
        <div className="row justify-content-center ps-1 pe-1">
          <h1 id="page-title" className="display-5">{t('vehdays.title')}</h1>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>


        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          {loading == 0 ? '' :
            <div className="mapspinner">
              <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
            </div>}

          <div className="row text-center pt-3 pb-2">
            <DatePicker
              selected={startDate}
              onChange={handleChangeDate}
              locale={i18n.language.substring(0,2)=='fr'?fr:en}
              inline
              startDate={startDate}
              endDate={endDate}
              selectsRange
              excludeDateIntervals={[
                {
                  start: new Date('2000-01-01'),
                  end: new Date('2023-07-01')
                },
                {
                  start: new Date(initDate),
                  end: new Date('2030-12-31')
                },
              ]}
            />
          </div>

          <div className="row justify-content-center">
            <div className="col text-center pt-2 pb-2">
              <h3>{(startFormat == endFormat) ?
                dayjs(startFormat).format('YYYY-MM-DD') :
              t('vehdays.from') + dayjs(startFormat).format('YYYY-MM-DD') + t('vehdays.to') + dayjs(endFormat).format('YYYY-MM-DD')}</h3>
            </div>
          </div>

          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center">
            <div className="col-lg-3">
              <select style={{ color: "black" }} onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                <option defaultValue>Opérateur</option>
                {userAgency.map((e) => (
                  <option value={e} key={e}
                  >{e}</option>
                ))}
              </select>
            </div>
          </div> : ''}

          <div className="row justify-content-center">
            <div className="col-lg-3">
              <select onChange={(event) => handleKPISelect(event)} className="form-select form-select-lg mb-3 mt-3">
                <option defaultValue>{t('vehdays.kpi.dist')}</option>
                <option defaultValue>{t('vehdays.kpi.runtime')}</option>
                <option defaultValue>{t('vehdays.kpi.speed')}</option>
                <option defaultValue>{t('vehdays.kpi.occ')}</option>
                <option defaultValue>{t('vehdays.kpi.datapoints')}</option>
              </select>
            </div>
          </div>

          {chartData.length > 0 ?
            <div id="overflow-table" className="container">
              <div className="row justify-content-center">
                <div className="col text-center">
                  <HeatMap
                    chartData={chartData}
                    kpiname={kpiname}
                  />
                </div>
              </div>
            </div> : ''}

        </div>
      </ > : ''
  );
  //}
}

export default VehicleDays;